// ----------------------------------------------------------------
// <copyright company='Microsoft Corporation'>
//     Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// ----------------------------------------------------------------
import { stringify } from 'query-string';
import HttpService from 'src/lib/HttpService';
const DEFAULT_SHIPPING_DEVICE_OFFER_URL = `api/ustrl/v2.0/devices/offers/shipping`;
const DEFAULT_SHIPPING_ACCESSORY_OFFER_URL = `api/ustrl/v2.0/devices/offers/fulfillmentShipping`;

export interface RequestBody {
    serialNumber: string;
    offerSku: string;
    symptomCode?: string;
    accessorySku?: string;
}
export interface ShippingOfferRequest {
    countryCode: string;
    postalCode: string;
    agentTier: string;
    payload: RequestBody[];
    isSoftwareOffer?: boolean;
    language?: string;
}

export default {
    async getDeviceShippingOffers(request: ShippingOfferRequest) {
        const { countryCode, postalCode, agentTier, payload, isSoftwareOffer, language } = request;
        const requestQuery = stringify({ countryCode, postalCode, agentTier, isSoftwareOffer, language });
        const response = await HttpService.proxiedApiCall({
            requestUrl: `${DEFAULT_SHIPPING_DEVICE_OFFER_URL}?${requestQuery}`,
            type: 'post',
            body: payload,
        });
        return response;
    },

    async getAccessoryShippingOffers(request: ShippingOfferRequest) {
        const { countryCode, postalCode, agentTier, payload, isSoftwareOffer, language } = request;
        const requestQuery = stringify({ countryCode, postalCode, agentTier, isSoftwareOffer, language });

        const response = await HttpService.proxiedApiCall({
            requestUrl: `${DEFAULT_SHIPPING_ACCESSORY_OFFER_URL}?${requestQuery}`,
            type: 'post',
            body: payload,
        });
        return response;
    },
};
